import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { ITchatUser } from '../../../models/server/interface/tchat-user.interface';

@Component({
    selector: 'app-tchat-user-identity',
    templateUrl: './tchat-user-identity.component.html',
    styleUrls: ['./tchat-user-identity.component.scss'],
    imports: [NgClass, MatBadgeModule, MatIconModule]
})
export class TchatUserIdentityComponent {
    /**
     * Utilisateur ayant envoyé le message.
     */
    @Input()
    public user: ITchatUser;

    /**
     * Valeur indiquant si l'utilisateur ayant envoyé le message correspond à l'utilisateur connecté.
     */
    @Input()
    public isCurrentUser: boolean;

    /**
     * Valeur indiquant si il s'agit d'un tchat en live (true) ou de l'historique d'un tchat (false).
     */
    @Input()
    public isLiveTchat: boolean;

    /**
     * Nombre de notifications ??.
     */
    @Input()
    public notifications: number;
}
